import { AUDIENCE_TYPES, AUDIENCE_TYPES_ARRAY } from "posts/constants";
import { BORDER_RADIUS, COLORS, DEFAULT_BOX_SHADOW } from "utils/styles";
import Card, { CardTitle } from "./Card";
import React, { useState } from "react";

import CompareModal from "./CompareModal";
import Modal from "./CompareModal";
import styled from "styled-components";
import { getAudienceEmoji } from "posts/constants";

const Iframe = styled.iframe`
  ${DEFAULT_BOX_SHADOW};
  ${BORDER_RADIUS};
  border: 5px solid ${COLORS.WHITE};
`;

function PlaylistCard({ activeAudience }) {
  const [showCompare, setShowCompare] = useState(false);
  const renderPlaylist = (audience) => {
    let url = "https://open.spotify.com/embed/playlist/404-not-found";
    switch (audience) {
      case AUDIENCE_TYPES.TOUGH_COOKIES:
        url = "https://open.spotify.com/embed/playlist/35eGp3E1MhxXABe8iDJuxi";
        break;
      case AUDIENCE_TYPES.DONT_TREAD_ON_ME:
        url = "https://open.spotify.com/embed/playlist/1T38sDFhDIHa4nNnKQaI0g";
        break;
      case AUDIENCE_TYPES.PEOPLE_POWER:
        url = "https://open.spotify.com/embed/playlist/0WCzQktskq73MyWTE5Dn4k";
        break;
      case AUDIENCE_TYPES.IF_YOU_SAY_SO:
        url = "https://open.spotify.com/embed/playlist/5tB6mZl8OR3lAop0qobS9H";
        break;
    }
    return (
      <Iframe
        title={`${audience} Spotify playlist`}
        src={url}
        width="100%"
        height="380"
        frameborder="0"
        allowtransparency="true"
        allow="encrypted-media"
      />
    );
  };

  return (
    <Card>
      <CardTitle
        onCompareClick={() => {
          setShowCompare(true);
        }}
      >
        Playlist
      </CardTitle>
      {renderPlaylist(activeAudience)}
      <CompareModal
        centered
        size="xl"
        show={showCompare}
        onHide={() => {
          setShowCompare(false);
        }}
      >
        <CompareModal.Header closeButton>
          <CompareModal.Title>Compare Audiences – Playlists</CompareModal.Title>
        </CompareModal.Header>
        <CompareModal.Body>
          <CompareModal.Grid>
            {AUDIENCE_TYPES_ARRAY.map((type, i) => {
              return (
                <CompareModal.GridColumn key={`playlist-compare-${i}`}>
                  <CompareModal.GridColumnTitle>
                    {getAudienceEmoji(type)}
                    {type}
                  </CompareModal.GridColumnTitle>
                  <CompareModal.GridColumnContent>
                    {renderPlaylist(type)}
                  </CompareModal.GridColumnContent>
                </CompareModal.GridColumn>
              );
            })}
          </CompareModal.Grid>
        </CompareModal.Body>
      </CompareModal>
    </Card>
  );
}

export default PlaylistCard;
